import { z } from 'zod'

export const CreateQueryValidationSchema = z.object({
  study_site_id: z.string().uuid({
    message: 'Please select a valid site',
  }),
  study_qc_task_id: z.string().uuid().optional().or(z.literal('')),
  study_subject_id: z.string().uuid({ message: 'Please select a valid subject' }),
  study_timepoint_submission_id: z.string().uuid({ message: 'Please select a valid timepoint' }),
  query_template: z.string().min(1),
  category: z.string().min(1, { message: 'Please select a valid category' }),
  study_timepoint_container_submission_ids: z.array(z.string().uuid()).optional().default([]),
  query_assignee_ids: z.array(z.string().uuid()).min(1, { message: 'Please select at least one assignee' }),
  initial_message_title: z.string().min(1, { message: 'Please enter a valid message title' }),
  initial_message_body: z.string().min(1, { message: 'Please enter a valid message body' }),
  cc_user_ids: z.array(z.string()).optional().default([]),
  requires_timepoint_resubmission: z.boolean().default(false),
})
export type CreateQueryFormData = z.infer<typeof CreateQueryValidationSchema>

export const ReopenQueryValidationSchema = z
  .object({
    reason: z.string().min(1, { message: 'Please provide a valid reason' }),
    container_ids: z.array(z.string().uuid()).optional(),
    requires_timepoint_resubmission: z.boolean().default(false),
  })
  .refine(
    (data) => {
      if (data.requires_timepoint_resubmission && (!data.container_ids || data.container_ids.length === 0)) {
        return false
      }
      return true
    },
    {
      message: 'Please select at least one container submission',
      path: ['container_ids'],
    },
  )

export type ReopenQueryFormData = z.infer<typeof ReopenQueryValidationSchema>
